// Google Analytics 类型声明
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

import { useChatStore } from "@/stores/chatStore";
import { externalFeatures } from "@/constant";

interface TrackEventParams {
  event: string;
  category: string;
  action: string;
  tag?: string;
  tag_value?: string;
}

type AnalyticsContext = Record<string, any>;
type AnalyticsContextProvider = () => AnalyticsContext;

const analyticsContextProviders: AnalyticsContextProvider[] = [];

export const registerAnalyticsContextProvider = (
  provider: AnalyticsContextProvider,
) => {
  analyticsContextProviders.push(provider);
  return () => {
    const index = analyticsContextProviders.indexOf(provider);
    if (index > -1) {
      analyticsContextProviders.splice(index, 1);
    }
  };
};

/**
 * {
 *   "eventDetails.action": "casa_click",
 *   "eventDetails.category": "quick_response",
 *   "eventDetails.conversationId": 820,
 *   "eventDetails.conversationStatus": "closed",
 *   "event": "trackEvent",
 *   "gtm.uniqueEventId": 55,
 *   "eventDetails.label": "0.0.1",
 *   "eventDetails.tag": "button_type",
 *   "eventDetails.tag_value": "quick_response_option"
 * }
 */

export const trackEvent = ({
  event,
  category,
  action,
  tag,
  tag_value,
  ...rest
}: TrackEventParams) => {
  if (externalFeatures && typeof externalFeatures.trackEvent === "function") {
    const { version } = useChatStore.getState();
    const dynamicContext = analyticsContextProviders.reduce(
      (acc, provider) => ({ ...acc, ...provider() }),
      {},
    );
    const params = {
      category,
      action,
      label: version,
      tag,
      tag_value,
      ...dynamicContext,
      ...rest,
    };

    return externalFeatures.trackEvent(
      event,
      Object.fromEntries(
        Object.entries(params).map(([k, v]) => [`eventDetails.${k}`, v]),
      ),
    );
  } else {
    console.warn("trackEvent feature is not implemented");
    return Promise.resolve();
  }
};

export const TRACK_EVENT = "trackEvent";

export const API_TAG = "api_type";
export const BUTTON_TAG = "button_type";
export const LINK_TAG = "link_type";

export const CLICK_ACTION = "casa_click";
export const SUBMIT_ACTION = "casa_submit";
